export enum STRUM_PATTERN {
	ROCK = '[Rock Strum] DxDUxUDU',
	SIXTEENTH = 'DxDU, DxDU, DxDU UDUDD',
	STANDARD = 'DxDxDxDU',
	TRAVIS_PICKING = 'Travis Picking',
}
